import PreBalanceAddition from 'sections/dashboard/preBalanceAddition';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { getCompanyBalances, isLoading } from 'state/reducers/balance.reducers';
import { Page } from '../theme/elements/Page';
import WaitingMessage from 'components/WaitingMessage';
import Dashboard from 'sections/dashboard/';
import { useEffect } from 'react';
import { toggleLang } from 'state/reducers/translation.reducers';

export default function DashboardApp() {
  const dispatch = useAppDispatch();
  const companyBalances = useAppSelector(getCompanyBalances);
  const loading = useAppSelector(isLoading);

  useEffect(() => {
    dispatch(toggleLang(localStorage.getItem('language') || 'he'));
  }, []);

  return (
    <Page>
      <>
        {loading && <WaitingMessage imageKey="page.dashboard.loading.icon" />}
        {!loading && <>{companyBalances?.length > 0 ? <Dashboard /> : <PreBalanceAddition />}</>}
      </>
    </Page>
  );
}
